/**
 * WebAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { UserRoleEditModel } from '../model/userRoleEditModel';
import { UserRoleViewModel } from '../model/userRoleViewModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserRoleService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param userLoginId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserRolesUserLoginIdGet(userLoginId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<UserRoleViewModel>>;
    public apiUserRolesUserLoginIdGet(userLoginId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserRoleViewModel>>>;
    public apiUserRolesUserLoginIdGet(userLoginId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserRoleViewModel>>>;
    public apiUserRolesUserLoginIdGet(userLoginId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userLoginId === null || userLoginId === undefined) {
            throw new Error('Required parameter userLoginId was null or undefined when calling apiUserRolesUserLoginIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserRoleViewModel>>('get',`${this.basePath}/api/user-roles/${encodeURIComponent(String(userLoginId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userLoginId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserRolesUserLoginIdPost(userLoginId: number, body?: Array<UserRoleEditModel>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiUserRolesUserLoginIdPost(userLoginId: number, body?: Array<UserRoleEditModel>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiUserRolesUserLoginIdPost(userLoginId: number, body?: Array<UserRoleEditModel>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiUserRolesUserLoginIdPost(userLoginId: number, body?: Array<UserRoleEditModel>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userLoginId === null || userLoginId === undefined) {
            throw new Error('Required parameter userLoginId was null or undefined when calling apiUserRolesUserLoginIdPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/user-roles/${encodeURIComponent(String(userLoginId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userLoginId 
     * @param roleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserRolesUserLoginIdRoleIdDelete(userLoginId: number, roleId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiUserRolesUserLoginIdRoleIdDelete(userLoginId: number, roleId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiUserRolesUserLoginIdRoleIdDelete(userLoginId: number, roleId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiUserRolesUserLoginIdRoleIdDelete(userLoginId: number, roleId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userLoginId === null || userLoginId === undefined) {
            throw new Error('Required parameter userLoginId was null or undefined when calling apiUserRolesUserLoginIdRoleIdDelete.');
        }

        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling apiUserRolesUserLoginIdRoleIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/user-roles/${encodeURIComponent(String(userLoginId))}/${encodeURIComponent(String(roleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userLoginId 
     * @param roleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserRolesUserLoginIdRoleIdGet(userLoginId: number, roleId: number, observe?: 'body', reportProgress?: boolean): Observable<UserRoleViewModel>;
    public apiUserRolesUserLoginIdRoleIdGet(userLoginId: number, roleId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserRoleViewModel>>;
    public apiUserRolesUserLoginIdRoleIdGet(userLoginId: number, roleId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserRoleViewModel>>;
    public apiUserRolesUserLoginIdRoleIdGet(userLoginId: number, roleId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userLoginId === null || userLoginId === undefined) {
            throw new Error('Required parameter userLoginId was null or undefined when calling apiUserRolesUserLoginIdRoleIdGet.');
        }

        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling apiUserRolesUserLoginIdRoleIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserRoleViewModel>('get',`${this.basePath}/api/user-roles/${encodeURIComponent(String(userLoginId))}/${encodeURIComponent(String(roleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
